import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { facebook, instagram, yelp, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#C60000" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center black bold>
            {/* <CFLink
              target="_blank"
              href="https://www.facebook.com/NomaJapaneseRestaurant/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Tsuki Sushi Facebook"
              />
            </CFLink> */}
            <CFLink
              target="_blank"
              href="https://www.instagram.com/tsuki.coquitlam/?utm_source=ig_web_button_share_sheet"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Tsuki Sushi Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#C60000" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            {/* <CFLink
              target="_blank"
              href="https://www.facebook.com/NomaJapaneseRestaurant/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Tsuki Sushi Facebook"
              />
            </CFLink> */}
            <CFLink
              target="_blank"
              href="https://www.instagram.com/tsuki.coquitlam/?utm_source=ig_web_button_share_sheet"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Tsuki Sushi Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
